import {withStyles} from "@material-ui/core/styles";
import {Theme} from "@material-ui/core";
import React from "react";

const styles = (theme: Theme) => {
    return ({
        root: {
            minWidth: 250,
            margin: theme.spacing(4)
        },
        dates: {
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
                alignItems: 'flex-start'
            }
        },
        action: {
            justifyContent: 'flex-end'
        },
        table: {
            marginTop: '2rem',
            display: 'flex',
            justifyContent: 'center'
        }
    });
};

const withReportDownloadComponentStyle = (WrappedComponent: React.FC<any>) => withStyles(styles)(WrappedComponent)
export default withReportDownloadComponentStyle;
